import { mimeMapping } from '../../../components/files/mimes';

(function() {
  'use strict';

  function FilesTableController(Files, FileUpload, Turnitin, Notify, $translate) {
    var ctrl = this;

    ctrl.files = [];
    ctrl.display = 'table';

    ctrl.$onInit = async function() {
      let files = ctrl.model || [];
      if (!Array.isArray(files)) {
        files = [files];
      }
      var submission = null;
      if (ctrl.turnitinEnabled) {
        const subObj = await Turnitin.getByOrigin(
          ctrl.docId,
          ctrl.fieldId,
          ''
        );
        submission = subObj.lastSubmission;
      }
      // Fetch submissions per file in parallel
      var submissions = {};
      if (ctrl.turnitinEnabled) {
        var results = await Promise.all(files.map(function(model) {
          if (model.key) {
            return Turnitin.getByOrigin(ctrl.docId, ctrl.fieldId, model.key)
              .catch(function() { return null; });
          }
          return null;
        }));
        files.forEach(function(model, i) {
          if (results[i] && results[i].lastSubmission) {
            submissions[model.key] = results[i].lastSubmission;
          }
        });
      }

      ctrl.files = files.map(function(model) {
        let file = {
          filename: model.filename,
          type: mimeMapping[model.contentType] ?? model.type ?? model.filename.split('.').pop(),
          contentType: model.contentType,
          size: model.size,
          model: model,
          buttons: []
        };
        // The download button
        file.buttons.push({
          label: $translate.instant('Download'),
          icon: 'download',
          klass: 'text-primary',
          action: function(file) {
            if (file.model.b64Content) {
              // If b64Content is available, use it for direct download
              FileUpload.downloadFromBase64(file.model.b64Content, file.contentType, file.filename);
            } else {
              // If b64Content is not available, fall back to URL download
              FileUpload.getDownloadUrl(file.model, { oid: ctrl.docId })
                .then(function(res) {
                  window.open(res.url, '_blank');
                })
                .catch(function(err) {
                  console.error(err);
                  Notify.error(err.message || 'The file cannot be downloaded');
                });
            }
          }
        });

        // Get submission for this specific file
        var fileSubmission = submissions[model.key] || submission || null;

        if (fileSubmission) {
          var validSubmission = typeof fileSubmission.error_code === 'undefined';
          file.plagiarism = {
            score: fileSubmission.score,
            status: validSubmission ? fileSubmission.state.state : 'error',
            details: validSubmission ? 'Similarity score:' : fileSubmission.error_message
          };
          if (validSubmission) {
            file.buttons.push({
              label: $translate.instant('View report'),
              icon: 'chart-pie',
              klass: 'text-primary',
              action: function() {
                Turnitin.openViewer(fileSubmission);
              }
            });
          }
        }
        // The preview button
        if (Files.canPreview(model.contentType)) {
          file.buttons.push({
            label: $translate.instant('Preview'),
            icon: 'view',
            klass: 'text-primary',
            action: function(file) {
              Files.openPreviewModal(file.model, ctrl.docId);
            }
          });
        }
        return file;
      });

      if (['table', 'list'].includes(ctrl.displayAs)) {
        ctrl.display = ctrl.displayAs;
      }
    };
  }

  FilesTableController.$inject = [
    'FilesService',
    'FileUploadService',
    'TurnitinService',
    'NotifyService',
    '$translate'
  ];

  angular.module('widgets.files')
    .component('kzFilesTable', {
      templateUrl: 'app/blocks/widgets/files/files-table.html',
      controller: FilesTableController,
      bindings: {
        displayAs: '@',
        model: '=',
        docId: '<',
        fieldId: '=',
        turnitinEnabled: '='
      }
    });
})();
